// extracted by mini-css-extract-plugin
module.exports = {"underlay":"fb3__D","dialog":"WYpYR5","title":"fhpKa_","padding":"_8AXk6g","small":"Btskng","medium":"jvCiQJ","large":"y9PC47","xlarge":"ny_67w","close":"_6iWCi9","header":"bL51wr"};